<template>
    <div>
        <div>
            <table class="am-discount scrollabletable">
                <thead>
                    <tr>
                        <th @click="sort('discountProductName')">Product<span><img v-if="sortData.currentSort === 'discountProductName'" :src="sorterArrow"></span></th>
                        <th @click="sort('discountType')">Type<span><img v-if="sortData.currentSort === 'discountType'" :src="sorterArrow"></span></th>
                        <th @click="sort('amount')">Discount<span><img v-if="sortData.currentSort === 'amount'" :src="sorterArrow"></span></th>
                        <th @click="sort('effectiveDate')">Effective Date<span><img v-if="sortData.currentSort === 'effectiveDate'" :src="sorterArrow"></span></th>
                        <th @click="sort('expirationDate')">Expiration Date<span><img v-if="sortData.currentSort === 'expirationDate'" :src="sorterArrow"></span></th>
                        <th @click="sort('discountStatus')">Status<span><img v-if="sortData.currentSort === 'discountStatus'" :src="sorterArrow"></span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="discount in pageDiscountsList" :key="discount.key">
                        <td>{{discount.discountProductName}}</td>
                      <td>{{discount.discountType}}</td>
                        <td>
                            <div v-if="discount.amountType === 'A'">${{ discount.amount }}</div>
                            <div v-else>{{ discount.amount }}%</div>
                        </td>
                        <td>
                            <div v-if="discount.discountType !== 'Lifetime'">{{discount.effectiveDate | moment("MM/DD/YYYY") }} </div>
                        </td>
                        <td>
                            <div v-if="discount.discountType !== 'Lifetime'">{{discount.expirationDate | moment("MM/DD/YYYY")}} </div>
                        </td>
                        <td>{{discount.discountStatus}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="am-discounts-pagination" v-show="discountList.length > pageSize">
            <pagination :allData="discountList" :pageSize="pageSize" :sortData="sortData" @setPageData="setPageData"></pagination>
        </div>
    </div>
</template>

<script>
import api from './../http'
import pagination from '@/components/pagination/pagination.vue'
import sort from '@/mixins/tableSorter'
export default {
  data: function () {
    return {
      name: 'Discount',
      pageSize: 15,
      pageDiscountsList: []
    }
  },

  components: {
    pagination
  },

  mixins: [sort],

  props: {
    accountId: {
      type: Number,
      default: 0
    }
  },

  asyncComputed: {
    discountList: {
      get () {
        let self = this
        return api.makeRequest('/backoffice/discountsList/' + self.accountId).then(
          (data) => {
            if (typeof data.data.discountsData === "undefined") {
              return []
            }

            return data.data.discountsData
          }
        )
      },
      default: []
    }
  },

  methods: {
    setPageData (data) {
      this.pageDiscountsList = data
    }
  }
}
</script>

<style>
    .am-discount {
        width: 100%;
    }
    .am-discount td{
        border-top: 1px solid #ddd;
        height: 25px;
    }

    .am-discount thead {
      color: white;
      background-color: #444444;
    }

    .am-discount th{
      padding-bottom:5px;
      cursor: pointer;
    }

    .am-discount>tbody>tr:nth-child(odd)>td, .am-discount>tbody>tr:nth-child(odd)>th {
        background-color: #f9f9f9;
    }
    .scrollabletable thead,.scrollabletable tbody tr{
      display: table;
      width:100%;
      table-layout: fixed;
    }
    .scrollabletable tbody{
      display: block;
      max-height: 550px;
      overflow-y: auto;
    }
    .am-discounts-pagination {
      text-align: right;
      padding: 10px 0 0 0;
    }
</style>
